import { Transition } from '@headlessui/react';
import { useLockedBody } from 'usehooks-ts';
import cx from 'classnames';

/**
 *
 * @property {boolean} isOpen
 * @property {()=> void} onClose
 * @property {boolean} timeClose
 */
const SlideDialog = ({
  isOpen = false,
  onClose = () => console.log('Modal'),
  timeClose = false,
  children,
}) => {
  return (
    <Transition
      show={isOpen}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 translate-y-6"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
      className="fixed  w-full z-[100] bottom-0"
    >
      <div className="w-full" id="slide">
        <span
          className="hidden inline-block align-middle h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div>{children}</div>
      </div>
    </Transition>
  );
};

export default SlideDialog;
